import { render, staticRenderFns } from "./AdminGeneralTextData.vue?vue&type=template&id=62a763ae"
import script from "./AdminGeneralTextData.vue?vue&type=script&lang=js"
export * from "./AdminGeneralTextData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports